import React, { FunctionComponent, ComponentProps } from 'react';
import { Icon } from '../../misc/Icon/Icon';
import { SyncIcon } from '../../synchronization/SyncIcon/SyncIcon';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { BreadcrumbBar } from '../BreadcrumbBar/BreadcrumbBar';
import styles from './Navbar.module.css';

export type NavbarProps = ComponentProps<'div'> & {
  onMenuIconClick: () => void;
  onSyncIconClick: () => void;
};

export const Navbar: FunctionComponent<NavbarProps> = React.memo((props) => {
  const { className, onMenuIconClick, onSyncIconClick, ...remainingProps } =
    prepareProps({ props, ignoreChildren: true });

  return (
    <div
      {...remainingProps}
      className={classes(className, styles.placeholder)}
    >
      <div className={styles.fixedContent}>
        <nav className={classes(styles.nav)}>
          <div
            className={styles.menuIconWrapper}
            onClick={onMenuIconClick}
            data-testid="Navbar.MenuIconWrapper"
          >
            <Icon name="bars"></Icon>
          </div>
          <div
            className={styles.rightIconsWrapper}
            onClick={onSyncIconClick}
            data-testid="Navbar.SyncIconWrapper"
          >
            <SyncIcon></SyncIcon>
          </div>
        </nav>
        <BreadcrumbBar></BreadcrumbBar>
      </div>
    </div>
  );
});
